import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Masquerade } from "../../../services/masquerade.service";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    @if (!data.bulkEdit) {
                        <div>
                            <s25-ng-masquerade-mapping
                                [item]="data.masquerade"
                                [mapping]="true"
                                (saved)="onSaved()"
                                (cancelled)="onCancelled()"
                            ></s25-ng-masquerade-mapping>
                        </div>
                    }
                    @if (data.bulkEdit) {
                        <div>
                            <s25-ng-masquerade-bulk-edit
                                [items]="data.masquerades"
                                (saved)="onSaved()"
                                (cancelled)="onCancelled()"
                            ></s25-ng-masquerade-bulk-edit>
                        </div>
                    }
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEditMasqueradeComponent
    extends ModalComponent<{
        masquerade?: Masquerade;
        masquerades?: any;
        reference?: string;
        bulkEdit?: boolean;
        onSave?: () => unknown;
        onCancel?: () => unknown;
    }>
    implements OnInit
{
    isInit = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved() {
        this.data.onSave?.();
        this.data.closeModal();
    }

    onCancelled() {
        this.data.closeModal();
    }
}
